import { ValidationFunctionMapType } from "../components/validateAPI/ValidateAPITypes";
import store from "../stateManagement/store";
import { ChannelkartNetworkGetWithToken } from "./networkService";
import { setAPIState } from "../stateManagement/actions/validateAPIActions";

const emptyCheck = (data: any): boolean => {
    return !(!data || Object.keys(data).length === 0);
};

const keyCheck = (data: any, params: { key: string }): boolean => {
    if (!data || Object.keys(data).length === 0) return false;
    for (let i = 0; i < data.length; i++) {
        if (
            !data[i].hasOwnProperty(params.key) ||
            data[i][params.key] === null ||
            data[i][params.key] === undefined
        ) {
            return false;
        }
    }
    return true;
};

const productPricingMergeCheck = (
    _: any,
    params: { commonKey: string }
): Promise<boolean> => {
    return productPricingIntersection(params.commonKey).then((res) => res.length > 0).catch((err) => {
        console.error(err);
        return false;
    })
};

const productPricingMergeCurentDataCheck = (
    data: any,
    params: { commonKey: string }
): Promise<boolean> => {
    return productPricingIntersection(params.commonKey).then((res) => findIntersection(res, data, params.commonKey).length > 0).catch((err) => {
        console.error(err);
        return false
    })

};

const productPricingIntersection = async (commonKey: string): Promise<any> => {
    try {
        const { token } = store.getState().validateAPIState;
        const productData = await fetchApiData("products", token);
        const pricingData = await fetchApiData("productmetaData", token);
        return findIntersection(productData, pricingData, commonKey);
    } catch (err) {
        throw err;
    }
};

const findIntersection = (
    data1: Array<any>,
    data2: Array<any>,
    commonKey: string
): Array<any> => {
    try {
        if (!data1 || !data2)
            throw new Error("Data is null for finding intersection");
        if(!Array.isArray(data1) || !Array.isArray(data2))
            throw new Error("Data is not an array");
        if (!commonKey || commonKey.trim() === "")
            throw new Error("common key is incorrect");
        const lookupMap = new Map();
        data1.forEach((item: any) => lookupMap.set(item[commonKey], item));
        const result: Array<any> = [];

        data2.forEach((item) => {
            if (lookupMap.has(item[commonKey])) {
                result.push(item);
            }
        });
        return result;
    } catch (err) {
        throw err
    }
};

export const validationFunctionMap: ValidationFunctionMapType = {
    emptyCheck: emptyCheck,
    keyCheck: keyCheck,
    productPricingMergeCheck: productPricingMergeCheck,
    productPricingMergeCurentDataCheck: productPricingMergeCurentDataCheck,
};

export const fetchApiData = async(apiId: string, token: string): Promise<any> => {

    const currentAPIState = store.getState()?.validateAPIState?.APIState[apiId];
    if(currentAPIState!=="fetching" && currentAPIState=="cache"){
        return store.getState().validateAPIState.apiResponses[apiId].data;
    }
    else if(currentAPIState==="fetching"){
        await wait(3000);
        return await fetchApiData(apiId,token)
        
    }else{
        setAPIState("fetching",apiId);
        let res=null
        switch (apiId) {
            case "catalog":
                 res = await ChannelkartNetworkGetWithToken(
                    "/v1/catalogues?transformerout=catalogue&size=8000&page=0",
                    token
                );
                return res.data.features
            case "outletDetails":
                 res = await ChannelkartNetworkGetWithToken(
                    "/outletDetails?minimalResponse=true&size=1000&page=0&appType=android&appVersion=12.1.0",
                    token
                );
                return res.data.features
            case "productmetaData":
                 res = await ChannelkartNetworkGetWithToken(
                    "/productmetadata/v1/items?minimalResponse=true&size=10000&page=0&appType=android&appVersion=12.1.0",
                    token
                );
                return res.data.features
            case "products":
                 res = await ChannelkartNetworkGetWithToken(
                    "/products?size=5000&page=0&minimalResponse=true&appType=android&appVersion=12.1.0",
                    token
                );
                return res.data.features
            case "secondaryProduct":
                 res = await ChannelkartNetworkGetWithToken(
                    "/v1/secondaryProduct?minimalResponse=true&filter=activeStatus:active&size=1000&page=0&appType=android&appVersion=12.1.0",
                    token
                );
                return res.data.features
            case "bannerDistribution":
                 res = await ChannelkartNetworkGetWithToken(
                    "/v1/bannerDistribution?size=1000&page=0&appType=android&appVersion=12.1.0",
                    token
                );
                return res.data.features
            case "recommendedOrders":
                 res = await ChannelkartNetworkGetWithToken(
                    "/recommendedorders?minimalResponse=true&size=1000&page=0&appType=android&appVersion=12.1.0",
                    token
                );
                return res.data.features
            default:
                throw Error("Invalid API Id");
        }
    }
};

export const  checkAllValidationNotInProgress =(allValidationStatus:Record<string,string>): boolean=> {
    if(!allValidationStatus) return false;
    for (let id in allValidationStatus) {
        if (allValidationStatus[id] === "inProgress") return false;
    }
    return true;
}

export const wait = (delay:number)=>{
    return new Promise((resolve,reject)=>{
        setTimeout(()=>{
            resolve(1);
        },delay)
    })
}